import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-info-tags',
  templateUrl: 'info-tags.component.html',
  styleUrls: ['../common.scss']
})
export class InfoTagsComponent {

  @Input() total: number = 0;

  @Input() clickable: boolean = false;

  @Input() showZero: boolean = true;

  @Output() click: EventEmitter<void> = new EventEmitter();

  onClick() {

    this.click.emit();

  }

}
